function numberStr(number)
{
  switch(number)
  {
  case 1: return 'one'
  case 2: return 'two'
  default: return `${number}`
  }
}

function pluralize(word, count)
{
  switch(word)
  {
  default:
    if (count === 1)
      return word
    else 
      return `${word}s`
  }
}

function capitalize(str)
{
  return `${str.charAt(0).toLocaleUpperCase()}${str.slice(1)}`
}

function format(word, count, shouldCapitalize)
{
  let str = numberStr(count)
  if (shouldCapitalize) 
  {
    str = capitalize(str)
  }
  return `${str} ${pluralize(word, count)}`
}

export default pluralize
export {format, capitalize}




// WEBPACK FOOTER //
// ./src/etc/pluralize.js